export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./select-custom.vue?vue&type=template&id=01623ca3&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/select-custom/select-custom.vue?vue&type=template&id=01623ca3&
// module id = 1629
// module chunks = 0